/** E-mails autorizados a ver o menu e submenus de Assistências na navegação lateral. */
export const ASSISTENCIA_NAV_ALLOWED_EMAILS = [
  'alan.aliske@motomco.com.br',
  'vilmar.ferreira@motomco.com.br',
];

/** E-mails autorizados a ver/editar o campo Restrito do Site SGU. */
export const SGU_RESTRICTED_ALLOWED_EMAILS = [
  'alan.aliske@motomco.com.br',
  'vilmar.ferreira@motomco.com.br',
];

const normalizeEmail = (email) => (email || '').trim().toLowerCase();

export const canAccessAssistenciaNavigation = (user) => {
  return ASSISTENCIA_NAV_ALLOWED_EMAILS.includes(normalizeEmail(user?.email));
};

export const canEditSguRestrictedPermission = (user) => {
  const email = normalizeEmail(user?.email || user?.username);
  return SGU_RESTRICTED_ALLOWED_EMAILS.includes(email);
};
